<div #scrollContainer class="scroll-container" (wheel)="onWheel($event)">
    <div routerLink="/" id="mobile-arrow-back-to-homepage" class="only-mobile padding-mobile-left-right pointer">
        <a>
            <img src="img/legals/arrow-back.svg" alt="arrow back">
        </a>
    </div>
    <div #start id="legals-panel-one" class="desktop-full-width align-items-center">
        <app-top-bar></app-top-bar>
        <div class="padding-mobile-left-right d-flex just-cont-space-bet mobile-flex-dir-column">
            <h2>{{ contentService.content().legalNotes.title }}</h2>
            <div class="content ma-le-56px">
                <div id="imprint">
                    <h3>{{ contentService.content().legalNotes.imprint.header }}</h3>
                    <ul>
                        <li>{{ contentService.content().general.name }}</li>
                        <li>{{ contentService.content().general.address.street }}</li>
                        <li>{{ contentService.content().general.address.zip + ' ' +
                            contentService.content().general.address.city }}</li>
                    </ul>
                    <p>{{ contentService.content().legalNotes.imprint.emailKey }}:
                        <a href="mailto: {{ contentService.content().general.email }}">{{
                            contentService.content().general.email}}</a>
                    </p>
                </div>
                <div id="legal-text-part-one">
                    @for (paragraph of contentService.content().legalNotes.main.slice(0, 3); track paragraph.header)
                    {
                    <div>
                        <h3>{{ paragraph.header }}</h3>
                        <p>{{ paragraph.text }}</p>
                    </div>
                    }
                </div>
            </div>
        </div>
        <app-switch-arrow class="pointer" (click)="triggerScroll('legalsPanelTwo')"></app-switch-arrow>
    </div>

    <div #legalsPanelTwo id="legals-panel-two"
        class="just-cont-space-bet mobile-flex-dir-column desktop-full-width">
        <div class="padding-mobile-left-right">
            <div id="legal-text-part-two" class="content ma-le-317px">
                @for (paragraph of contentService.content().legalNotes.main.slice(3); track paragraph.header) {
                <div>
                    <h3>{{ paragraph.header }}</h3>
                    <p>{{ paragraph.text }}</p>
                </div>
                }
                <div id="any-questions">
                    <p>
                        {{ contentService.content().legalNotes.anyQuestions.text }}
                        <a href="mailto: {{ contentService.content().general.email }}">{{
                            contentService.content().general.email}}</a>
                    </p>
                    <p>{{ contentService.content().legalNotes.anyQuestions.date }}</p>
                </div>
            </div>
        </div>
        <app-footer [scrollContainer] = "scrollContainer"></app-footer>
    </div>
</div>